import * as React from "react";
import { InputContainer, Text, FloatingBox } from "../../elements";
import ToggleFloatingLayer from "../ToggleFloatingLayer";
import { DatePicker } from "../";
import { DatePickerProps } from "../DatePicker";
import { useSelect } from "@hubper/theme";
import { format } from "date-fns";

const defaultRenderValue = (
  value: DatePickerProps["value"] | DatePickerProps["start"],
  end?: DatePickerProps["end"]
): string | undefined | null => {
  if (end) {
    return `${value && format(value, "YYYY-MM-DD")} - ${end &&
      format(end, "YYYY-MM-DD")}`;
  } else {
    return value && format(value, "YYYY-MM-DD");
  }
};

type Props = {
  style?: React.CSSProperties;
  className?: string;
  label: string;
  disabled?: boolean;
  placeholder?: string;
  error?: string;
  stretch?: boolean;
  renderValue?: (
    value: DatePickerProps["value"] | DatePickerProps["start"],
    end?: DatePickerProps["end"]
  ) => string | null | undefined;
} & DatePickerProps;

function DateInput(
  {
    style,
    className,
    value,
    label,
    disabled,
    placeholder,
    renderValue = defaultRenderValue,
    stretch,
    error,
    colorType,
    cellSize,
    range,
    onChange,
    onRangeChange,
    start,
    end,
    monthNames,
    dayNames
  }: Props,
  ref: any
) {
  const { space } = useSelect();

  return (
    <ToggleFloatingLayer
      closeOnOutsideClick
      layer={
        <FloatingBox>
          <DatePicker
            style={{ margin: space(4) }}
            monthNames={monthNames}
            dayNames={dayNames}
            range={range}
            onChange={onChange}
            value={value}
            start={start}
            end={end}
            colorType={colorType}
            cellSize={cellSize}
            onRangeChange={onRangeChange}
          />
        </FloatingBox>
      }
    >
      {({ toggle }) => (
        <InputContainer
          ref={ref}
          style={style}
          className={className}
          label={label}
          stretch={stretch}
          disabled={disabled}
          error={error}
          onClick={toggle}
        >
          <Text fs={-1} c={["grey", 3]} style={{ flex: 1 }}>
            {range
              ? renderValue(start, end) || placeholder
              : renderValue(value) || placeholder}
          </Text>
        </InputContainer>
      )}
    </ToggleFloatingLayer>
  );
}

export default React.forwardRef(DateInput);
